import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationDetoxificationPhase2DiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const ugt1a1 = getGenePalette(geneColors.UGT1A1);
  const ugt1a6 = getGenePalette(geneColors.UGT1A6);
  const ugt2b15 = getGenePalette(geneColors.UGT2B15);
  const sult1a1 = getGenePalette(geneColors.SULT1A1);
  const nat1 = getGenePalette(geneColors.NAT1);
  const nat2 = getGenePalette(geneColors.NAT2);
  const gstm1 = getGenePalette(geneColors.GSTM1);
  const gstp1 = getGenePalette(geneColors.GSTP1);
  const gstt1 = getGenePalette(geneColors.GSTT1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18382_42717)">
        <rect width={1024} height={934} transform="translate(0 176)" fill="white" />
        <g id="detoxification-diagram">
          <rect width={1024} height={934} transform="translate(0 176)" fill="white" />
          <g id="background">
            <rect width={910} height={798} transform="translate(56 239)" fill="#FFF1F2" />
            <g id="Report titles">
              <text
                id="25-Hydroxy Vitamin D"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={72.9609} y={276.16}>
                  Liver
                </tspan>
              </text>
            </g>
            <g id="gene-UGT1A1" {...geneGroupProps("UGT1A1", onGeneClick)}>
              <g id="gene-lozenge_5">
                <path
                  d="M445 393.5C445 391.291 446.791 389.5 449 389.5H541C543.209 389.5 545 391.291 545 393.5V421.5C545 423.709 543.209 425.5 541 425.5H449C446.791 425.5 445 423.709 445 421.5V393.5Z"
                  fill={ugt1a1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={469} y={412.948}>
                    UGT1A1
                  </tspan>
                </text>
                <path
                  id="*_3"
                  d="M555.748 385.906V388.324L551.818 388.195L554.064 391.434L551.861 392.73L549.874 389.231L547.887 392.73L545.684 391.434L547.93 388.195L544 388.324L544 385.906L547.93 386.035L545.684 382.796L547.887 381.5L549.874 384.999L551.861 381.5L554.064 382.796L551.818 386.035L555.748 385.906Z"
                  fill="black"
                />
              </g>
              <GeneSnpShapes
                id="ugt1a1"
                groupId="gene-snps"
                genePalette={ugt1a1}
                startX={453}
                startY={427.5}
                snpCount={getGeneSnpCount("UGT1A1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-UGT1A6" {...geneGroupProps("UGT1A6", onGeneClick)}>
              <g id="gene-lozenge_6">
                <path
                  d="M445 445.5C445 443.291 446.791 441.5 449 441.5H541C543.209 441.5 545 443.291 545 445.5V473.5C545 475.709 543.209 477.5 541 477.5H449C446.791 477.5 445 475.709 445 473.5V445.5Z"
                  fill={ugt1a6.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={467.109} y={464.948}>
                    UGT1A6
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="ugt1a6"
                groupId="gene-snps_2"
                genePalette={ugt1a6}
                startX={453}
                startY={479.5}
                snpCount={getGeneSnpCount("UGT1A6", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-UGT2B15" {...geneGroupProps("UGT2B15", onGeneClick)}>
              <g id="gene-lozenge_7">
                <path
                  d="M445 497.5C445 495.291 446.791 493.5 449 493.5H541C543.209 493.5 545 495.291 545 497.5V525.5C545 527.709 543.209 529.5 541 529.5H449C446.791 529.5 445 527.709 445 525.5V497.5Z"
                  fill={ugt2b15.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={463.578} y={516.948}>
                    UGT2B15
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="ugt2b15"
                groupId="gene-snps_3"
                genePalette={ugt2b15}
                startX={453}
                startY={531.5}
                snpCount={getGeneSnpCount("UGT2B15", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-SULT1A1" {...geneGroupProps("SULT1A1", onGeneClick)}>
              <g id="gene-lozenge_8">
                <path
                  d="M445 577.5C445 575.291 446.791 573.5 449 573.5H541C543.209 573.5 545 575.291 545 577.5V605.5C545 607.709 543.209 609.5 541 609.5H449C446.791 609.5 445 607.709 445 605.5V577.5Z"
                  fill={sult1a1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={467.023} y={596.948}>
                    SULT1A1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="sult1a1"
                groupId="gene-snps_4"
                genePalette={sult1a1}
                startX={453}
                startY={611.5}
                snpCount={getGeneSnpCount("SULT1A1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-NAT1" {...geneGroupProps("NAT1", onGeneClick)}>
              <g id="gene-lozenge_9">
                <path
                  d="M445 668.5C445 666.291 446.791 664.5 449 664.5H541C543.209 664.5 545 666.291 545 668.5V696.5C545 698.709 543.209 700.5 541 700.5H449C446.791 700.5 445 698.709 445 696.5V668.5Z"
                  fill={nat1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_5"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={477.648} y={687.948}>
                    NAT1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="nat1"
                groupId="gene-snps_5"
                genePalette={nat1}
                startX={453}
                startY={702.5}
                snpCount={getGeneSnpCount("NAT1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-NAT2" {...geneGroupProps("NAT2", onGeneClick)}>
              <g id="gene-lozenge_10">
                <path
                  d="M445 726.5C445 724.291 446.791 722.5 449 722.5H541C543.209 722.5 545 724.291 545 726.5V754.5C545 756.709 543.209 758.5 541 758.5H449C446.791 758.5 445 756.709 445 754.5V726.5Z"
                  fill={nat2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_6"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={476.508} y={745.948}>
                    NAT2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="nat2"
                groupId="gene-snps_6"
                genePalette={nat2}
                startX={453}
                startY={760.5}
                snpCount={getGeneSnpCount("NAT2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GSTM1" {...geneGroupProps("GSTM1", onGeneClick)}>
              <g id="gene-lozenge_11">
                <path
                  d="M445 812.5C445 810.291 446.791 808.5 449 808.5H541C543.209 808.5 545 810.291 545 812.5V840.5C545 842.709 543.209 844.5 541 844.5H449C446.791 844.5 445 842.709 445 840.5V812.5Z"
                  fill={gstm1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_7"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={470.867} y={831.948}>
                    GSTM1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gstm1"
                groupId="gene-snps_7"
                genePalette={gstm1}
                startX={453}
                startY={846.5}
                snpCount={getGeneSnpCount("GSTM1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GSTP1" {...geneGroupProps("GSTP1", onGeneClick)}>
              <g id="gene-lozenge_12">
                <path
                  d="M445 864.5C445 862.291 446.791 860.5 449 860.5H541C543.209 860.5 545 862.291 545 864.5V892.5C545 894.709 543.209 896.5 541 896.5H449C446.791 896.5 445 894.709 445 892.5V864.5Z"
                  fill={gstp1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_8"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={472.586} y={883.948}>
                    GSTP1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gstp1"
                groupId="gene-snps_8"
                genePalette={gstp1}
                startX={453}
                startY={898.5}
                snpCount={getGeneSnpCount("GSTP1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GSTT1" {...geneGroupProps("GSTT1", onGeneClick)}>
              <g id="gene-lozenge_13">
                <path
                  d="M445 916.5C445 914.291 446.791 912.5 449 912.5H541C543.209 912.5 545 914.291 545 916.5V944.5C545 946.709 543.209 948.5 541 948.5H449C446.791 948.5 445 946.709 445 944.5V916.5Z"
                  fill={gstt1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_9"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={472.961} y={935.948}>
                    GSTT1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gstt1"
                groupId="gene-snps_9"
                genePalette={gstt1}
                startX={453}
                startY={950.5}
                snpCount={getGeneSnpCount("GSTT1", expectedSnps, geneColors)}
              />
            </g>
            <g id="Report titles_2">
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={434.158} y={350.12}>
                  Detox Phase II
                </tspan>
              </text>
            </g>
            <path
              id="Vector 424"
              d="M329 618.202L328.367 617.904L328.249 618.153L328.333 618.415L329 618.202ZM428.86 406V405.3H428.416L428.227 405.702L428.86 406ZM443.126 406L436.126 401.959V410.041L443.126 406ZM428.86 461.052V460.352H428.476L428.269 460.677L428.86 461.052ZM443.126 461.052L436.126 457.011V465.094L443.126 461.052ZM428.86 511.601V510.901H428.557L428.349 511.122L428.86 511.601ZM443.126 511.601L436.126 507.559V515.642L443.126 511.601ZM428.86 591.677V590.977H428.769L428.68 591L428.86 591.677ZM443.126 591.677L436.126 587.635V595.718L443.126 591.677ZM426.343 684.265L425.95 684.844L426.128 684.965H426.343V684.265ZM440.608 684.265L433.608 680.224V688.306L440.608 684.265ZM428.86 740.318L428.318 740.762L428.528 741.018H428.86V740.318ZM443.126 740.318L436.126 736.277V744.36L443.126 740.318ZM428.86 827.902L428.228 828.203L428.418 828.602H428.86V827.902ZM449 827.902L442 823.86V831.943L449 827.902ZM428.86 879.451L428.206 879.701L428.378 880.151H428.86V879.451ZM449 879.451L442 875.409V883.492L449 879.451ZM428.86 931L428.193 931.213L428.349 931.7H428.86V931ZM449 931L442 926.959V935.041L449 931ZM329 618.202L329.633 618.5L429.494 406.298L428.86 406L428.227 405.702L328.367 617.904L329 618.202ZM428.86 406V406.7H436.826V406V405.3H428.86V406ZM329 618.202L329.591 618.578L429.451 461.428L428.86 461.052L428.269 460.677L328.409 617.827L329 618.202ZM428.86 461.052V461.752H436.826V461.052V460.352H428.86V461.052ZM329 618.202L329.511 618.681L429.371 512.079L428.86 511.601L428.349 511.122L328.489 617.724L329 618.202ZM428.86 511.601V512.301H436.826V511.601V510.901H428.86V511.601ZM329 618.202L329.18 618.879L429.04 592.353L428.86 591.677L428.68 591L328.82 617.526L329 618.202ZM428.86 591.677V592.377H436.826V591.677V590.977H428.86V591.677ZM329 618.202L328.607 618.781L425.95 684.844L426.343 684.265L426.736 683.686L329.393 617.623L329 618.202ZM426.343 684.265V684.965H434.308V684.265V683.565H426.343V684.265ZM329 618.202L328.458 618.645L428.318 740.762L428.86 740.318L429.402 739.875L329.542 617.759L329 618.202ZM428.86 740.318V741.018H436.826V740.318V739.618H428.86V740.318ZM329 618.202L328.368 618.503L428.228 828.203L428.86 827.902L429.492 827.601L329.632 617.901L329 618.202ZM428.86 827.902V828.602H442.7V827.902V827.202H428.86V827.902ZM329 618.202L328.346 618.452L428.206 879.701L428.86 879.451L429.514 879.201L329.654 617.952L329 618.202ZM428.86 879.451V880.151H442.7V879.451V878.751H428.86V879.451ZM329 618.202L328.333 618.415L428.193 931.213L428.86 931L429.527 930.787L329.667 617.989L329 618.202ZM428.86 931V931.7H442.7V931V930.3H428.86V931Z"
              fill="#282828"
            />
            <g id="Frame 468">
              <rect
                x={193.7}
                y={570.2}
                width={134.6}
                height={102.6}
                stroke="#282828"
                strokeWidth={1.4}
              />
              <g id="Rich Text Block">
                <text
                  id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={227.982} y={614.267}>
                    Activated{" "}
                  </tspan>
                  <tspan x={216.676} y={638.267}>
                    intermediates
                  </tspan>
                </text>
              </g>
            </g>
            <path
              id="Vector 424_2"
              d="M661 618.202L560.308 406H545.923M661 618.202L560.308 461.052H545.923M661 618.202L560.308 511.601H545.923M661 618.202L560.308 591.677H545.923M661 618.202L562.846 684.265H548.462M661 618.202L560.308 740.318H545.923M661 618.202L560.308 827.902H540M661 618.202L560.308 879.451H540M661 618.202L560.308 931H540"
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Frame 469">
              <rect
                x={662.7}
                y={497.2}
                width={182.6}
                height={234.6}
                stroke="#282828"
                strokeWidth={1.4}
              />
              <g id="Rich Text Block_2">
                <text
                  id="H2 Header"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={18}
                  letterSpacing="0em"
                >
                  <tspan x={690} y={544.647}>
                    Toxins
                  </tspan>
                </text>
                <text
                  id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={690} y={577.267}>
                    Exit through:{" "}
                  </tspan>
                  <tspan x={690} y={601.267}>
                    {" "}
                  </tspan>
                  <tspan x={711} y={625.267}>
                    Lung{" "}
                  </tspan>
                  <tspan x={711} y={649.267}>
                    Skin{" "}
                  </tspan>
                  <tspan x={711} y={673.267}>
                    Colon{" "}
                  </tspan>
                  <tspan x={711} y={697.267}>
                    Kidneys
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationDetoxificationPhase2Diagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={934}
    viewBox="0 176 1024 934"
    fill="none"
    {...props}
  >
    <MethylationDetoxificationPhase2DiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18382_42717">
        <rect width={1024} height={1110} fill="white" />
      </clipPath>
      <clipPath id="clip1_18382_42717">
        <rect width={1024} height={934} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationDetoxificationPhase2Diagram;
